(function (factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') {
    window.BMVariantAvailability = api;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { api.init(document); }, { once: true });
    else api.init(document);
  }
})(function () {
  'use strict';
  // Short labels match the languages supported by bm-preorder.liquid.
  // The date always describes dispatch, never delivery or arrival.
  var COPY = {
    en: ['In stock now', 'Pre-order · dispatches {date}', 'Out of stock', 'Available', 'Check availability'],
    de: ['Auf Lager', 'Vorbestellung · Versand ab {date}', 'Nicht auf Lager', 'Verfügbar', 'Verfügbarkeit prüfen'],
    fr: ['En stock', 'Précommande · expédition dès le {date}', 'En rupture de stock', 'Disponible', 'Vérifier la disponibilité'],
    nl: ['Op voorraad', 'Pre-order · verzending vanaf {date}', 'Niet op voorraad', 'Beschikbaar', 'Beschikbaarheid controleren'],
    it: ['Disponibile in magazzino', 'Preordine · spedizione dal {date}', 'Esaurito', 'Disponibile', 'Verifica disponibilità'],
    da: ['På lager nu', 'Forudbestilling · sendes fra {date}', 'Ikke på lager', 'Tilgængelig', 'Tjek tilgængelighed'],
    sv: ['I lager nu', 'Förbeställning · skickas från {date}', 'Slut i lager', 'Tillgänglig', 'Kontrollera tillgänglighet'],
    no: ['På lager nå', 'Forhåndsbestilling · sendes fra {date}', 'Utsolgt', 'Tilgjengelig', 'Sjekk tilgjengelighet'],
    nb: ['På lager nå', 'Forhåndsbestilling · sendes fra {date}', 'Utsolgt', 'Tilgjengelig', 'Sjekk tilgjengelighet'],
    fi: ['Varastossa nyt', 'Ennakkotilaus · lähetetään {date} alkaen', 'Loppu varastosta', 'Saatavilla', 'Tarkista saatavuus'],
    pt: ['Em stock', 'Pré-encomenda · envio a partir de {date}', 'Esgotado', 'Disponível', 'Verificar disponibilidade'],
    el: ['Σε απόθεμα', 'Προπαραγγελία · αποστολή από {date}', 'Εξαντλήθηκε', 'Διαθέσιμο', 'Έλεγχος διαθεσιμότητας'],
    bg: ['В наличност', 'Предварителна поръчка · изпращане от {date}', 'Изчерпан', 'Наличен', 'Проверете наличността'],
    hr: ['Na zalihi', 'Predbilježba · otprema od {date}', 'Nema na zalihi', 'Dostupno', 'Provjerite dostupnost'],
    ro: ['În stoc', 'Precomandă · expediere de la {date}', 'Stoc epuizat', 'Disponibil', 'Verifică disponibilitatea'],
    sl: ['Na zalogi', 'Prednaročilo · odprema od {date}', 'Ni na zalogi', 'Na voljo', 'Preveri razpoložljivost'],
    lt: ['Sandėlyje', 'Išankstinis užsakymas · išsiuntimas nuo {date}', 'Nėra sandėlyje', 'Galima užsisakyti', 'Tikrinti prieinamumą'],
    lv: ['Noliktavā', 'Priekšpasūtījums · nosūtīšana no {date}', 'Nav noliktavā', 'Pieejams', 'Pārbaudīt pieejamību'],
    et: ['Laos', 'Ettetellimus · väljasaatmine alates {date}', 'Laost otsas', 'Saadaval', 'Kontrolli saadavust'],
    lb: ['Op Lager', 'Virbestellung · Versand ab {date}', 'Net op Lager', 'Disponibel', 'Disponibilitéit préiwen'],
    mt: ['Fi stokk', 'Prenotazzjoni · jintbagħat mill-{date}', "M’hemmx fi stokk", 'Disponibbli', 'Iċċekkja d-disponibbiltà'],
    tr: ['Stokta', 'Ön sipariş · {date} tarihinden itibaren gönderilir', 'Stokta yok', 'Mevcut', 'Stok durumunu kontrol edin'],
    es: ['En stock', 'Reserva · envío desde el {date}', 'Agotado', 'Disponible', 'Consultar disponibilidad'],
    pl: ['W magazynie', 'Przedsprzedaż · wysyłka od {date}', 'Brak w magazynie', 'Dostępne', 'Sprawdź dostępność']
  };
  var KIND_INDEX = { stock: 0, preorder: 1, out: 2, available: 3, check: 4 };

  function textFor(kind, locale, date) {
    var key = String(locale || 'en').toLowerCase().split('-')[0];
    return (COPY[key] || COPY.en)[KIND_INDEX[kind]].replace('{date}', date || '');
  }

  function formatDate(iso, locale) {
    if (typeof iso !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return '';
    var date = new Date(iso + 'T00:00:00Z');
    if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== iso) return '';
    var dateLocale = /^en(?:-|$)/i.test(locale || 'en') ? 'en-GB' : locale;
    try { return new Intl.DateTimeFormat(dateLocale || 'en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' }).format(date); }
    catch (_) { return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' }).format(date); }
  }

  function lineStatus(line, locale) {
    var full = line.full === true || line.state === 'PREORDER_FULL';
    var date = formatDate(line.eta, locale);
    var kind = full || line.state === 'NO_DATE' ? 'out' : line.state === 'IN_STOCK' ? 'stock' : line.state === 'PREORDER' && date ? 'preorder' : 'check';
    var result = { kind: kind, text: textFor(kind, locale, date) };
    if (kind === 'preorder') result.eta = line.eta;
    return result;
  }

  function describeVariant(variant, preorderBox, locale) {
    if (!variant) return [{ kind: 'out', text: textFor('out', locale) }];
    var entry = preorderBox && preorderBox.variants && preorderBox.variants[String(variant.id)];
    if (entry && (!Array.isArray(entry.lines) || !entry.lines.length)) return [{ kind: 'check', text: textFor('check', locale) }];
    if (entry && Array.isArray(entry.lines) && entry.lines.length) {
      var lines = entry.lines.filter(function (line) { return line && typeof line === 'object'; });
      if (!lines.length) return [{ kind: 'check', text: textFor('check', locale) }];
      var descriptions = lines.map(function (line) { return lineStatus(line, locale); });
      var same = descriptions.every(function (item) { return item.kind === descriptions[0].kind && item.eta === descriptions[0].eta; });
      if (same) return [descriptions[0]];
      return descriptions.map(function (item, index) {
        var line = lines[index];
        var isPerth = /perth/i.test(line.name || '') || String(line.loc) === '108041601328';
        var isSydney = /sydney/i.test(line.name || '') || String(line.loc) === '79365669168';
        item.area = isPerth ? 'WA' : isSydney ? 'Rest of Australia' : String(line.name || line.scope || '');
        if (item.area) item.text = item.area + ': ' + item.text;
        return item;
      });
    }
    // Shopify's available flag includes continue-selling variants at zero stock.
    // Only a tracked, positive counter earns a physical in-stock promise.
    var kind;
    if (variant.available === false) kind = 'out';
    else if (!variant.inventory_management || variant.requires_shipping === false) kind = 'available';
    else if (Number.isFinite(Number(variant.inventory_quantity)) && Number(variant.inventory_quantity) > 0) kind = 'stock';
    else if (variant.inventory_policy === 'continue' || variant.available === true) kind = 'check';
    else kind = 'out';
    return [{ kind: kind, text: textFor(kind, locale) }];
  }

  function resolveVariant(variants, selectedOptions, optionIndex, optionValue) {
    var options = (selectedOptions || []).slice();
    options[optionIndex] = String(optionValue);
    return (variants || []).find(function (variant) {
      return Array.isArray(variant.options) && variant.options.length === options.length && variant.options.every(function (value, index) { return String(value) === String(options[index]); });
    }) || null;
  }

  function init(doc) {
    if (!doc || !doc.querySelectorAll) return;
    doc.querySelectorAll('[data-bmva-config]').forEach(function (node) {
      if (node.bmvaInitialized) return;
      var config;
      try { config = JSON.parse(node.textContent); } catch (_) { return; }
      if (!config || !Array.isArray(config.variants) || !config.variants.length) return;
      var main = doc.getElementById('MainContent') || doc.querySelector('main');
      if (!main) return;
      var candidates = Array.from(main.querySelectorAll('bm-gm3-configurator, bm-nano-configurator, product-info[data-product-id]'));
      var root = candidates.find(function (candidate) { return candidate.matches('bm-gm3-configurator,bm-nano-configurator') || String(candidate.dataset.productId) === String(config.productId); });
      if (!root) return;
      node.bmvaInitialized = true;
      mount(root, config, doc);
      // Some Dawn variants replace the whole product-info element. Watch only
      // its immediate parent for that case; ordinary changes stay root-scoped.
      var Observer = doc.defaultView && doc.defaultView.MutationObserver;
      if (Observer && root.parentElement) {
        var replacementObserver = new Observer(function () {
          if (root.isConnected) return;
          replacementObserver.disconnect();
          node.bmvaInitialized = false;
          init(doc);
        });
        replacementObserver.observe(root.parentElement, { childList: true });
      }
    });
  }

  function mount(root, config, doc) {
    var scheduled = false;
    var variants = config.variants;
    var byId = new Map(variants.map(function (variant) { return [String(variant.id), variant]; }));
    var locale = config.locale || doc.documentElement.lang || 'en';
    function statuses(variant) { return describeVariant(variant, config.preorderBox, locale); }
    function selectedVariant() {
      var id = root.dataset.selectedVariantId || root.querySelector('form[action*="/cart/add"] [name="id"], form[data-type="add-to-cart-form"] [name="id"]')?.value;
      return byId.get(String(id)) || byId.get(String(config.selectedId)) || variants[0];
    }
    function paint(host, items) {
      if (!host) return;
      var signature = JSON.stringify(items);
      var badge = Array.from(host.children).find(function (child) { return child.hasAttribute('data-bmva'); });
      if (badge && badge.dataset.bmvaSignature === signature) return;
      if (!badge) {
        badge = doc.createElement('span');
        badge.className = 'bmva'; badge.setAttribute('data-bmva', '');
        host.appendChild(badge);
        host.classList.add('bmva-host');
      }
      badge.dataset.bmvaSignature = signature;
      badge.replaceChildren();
      items.forEach(function (item) {
        var row = doc.createElement('span'); row.className = 'bmva__status bmva__status--' + item.kind;
        var dot = doc.createElement('span'); dot.className = 'bmva__dot'; dot.setAttribute('aria-hidden', 'true');
        var label = doc.createElement('span'); label.textContent = item.text;
        row.appendChild(dot); row.appendChild(label); badge.appendChild(row);
      });
    }
    function exactCards() {
      root.querySelectorAll('.bmc-package-option[data-variant-id], [data-mount-options] [data-variant-id]').forEach(function (card) {
        var variant = byId.get(String(card.dataset.variantId));
        if (!variant) return;
        paint(card, statuses(variant));
        var obsolete = card.querySelector('[data-mount-badge]');
        if (obsolete && !obsolete.hidden) obsolete.hidden = true;
      });
      root.querySelectorAll('[data-compare-avail]').forEach(function (cell) {
        var mount = cell.dataset.compareAvail;
        var card = Array.from(root.querySelectorAll('[data-mount-options] [data-variant-id]')).find(function (item) { return item.dataset.mount === mount; });
        var variant = card && byId.get(String(card.dataset.variantId));
        if (!variant) return;
        var value = statuses(variant).map(function (item) { return item.text; }).join(' · ');
        if (cell.textContent !== value) cell.textContent = value;
      });
    }
    function optionGroups(picker) {
      return Array.from(picker.querySelectorAll('fieldset, .product-form__input--dropdown')).filter(function (group) {
        return group.querySelector('input[type="radio"], select') && !group.parentElement.closest('fieldset, .product-form__input--dropdown');
      });
    }
    function nativeOptions() {
      root.querySelectorAll('variant-selects').forEach(function (picker) {
        var groups = optionGroups(picker);
        var selected = (selectedVariant().options || []).slice();
        groups.forEach(function (group, index) {
          var checked = group.querySelector('input[type="radio"]:checked, select');
          if (checked) selected[index] = checked.value;
        });
        groups.forEach(function (group, index) {
          var radios = Array.from(group.querySelectorAll('input[type="radio"]'));
          var select = group.querySelector('select');
          var choices = select ? Array.from(select.options) : radios;
          var compact = !!select || radios.some(function (input) { return input.classList.contains('bm-swatch__input') || input.classList.contains('swatch-input__input'); });
          var list = Array.from(group.children).find(function (child) { return child.hasAttribute('data-bmva-list'); });
          if (compact && !list) { list = doc.createElement('span'); list.className = 'bmva-list'; list.setAttribute('data-bmva-list', ''); group.appendChild(list); }
          choices.forEach(function (choice) {
            var variant = resolveVariant(variants, selected, index, choice.value);
            // Hidden combinations stay hidden; an impossible pair earns no stock promise.
            var hidden = choice.classList.contains('bm-opt-hidden') || choice.hidden;
            var items = statuses(variant);
            if (compact) {
              var row = Array.from(list.children).find(function (child) { return child.dataset.bmvaValue === choice.value; });
              if (!row) {
                row = doc.createElement('span'); row.className = 'bmva-list__row'; row.dataset.bmvaValue = choice.value;
                var name = doc.createElement('span'); name.className = 'bmva-list__name'; name.textContent = choice.value;
                row.appendChild(name); list.appendChild(row);
              }
              if (row.hidden !== hidden) row.hidden = hidden;
              paint(row, items);
            } else {
              var label = Array.from(group.querySelectorAll('label[for]')).find(function (item) { return item.htmlFor === choice.id; });
              if (label) paint(label, items);
            }
          });
        });
      });
    }
    function singleVariant() {
      if (variants.length !== 1 || root.querySelector('variant-selects, [data-package-options], [data-mount-options]')) return;
      var buttons = root.querySelector('.product-form__buttons');
      if (!buttons) return;
      var host = Array.from(buttons.children).find(function (child) { return child.hasAttribute('data-bmva-single'); });
      if (!host) { host = doc.createElement('span'); host.className = 'bmva-single'; host.setAttribute('data-bmva-single', ''); buttons.prepend(host); }
      paint(host, statuses(variants[0]));
    }
    function render() { scheduled = false; exactCards(); nativeOptions(); singleVariant(); }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      var raf = doc.defaultView && doc.defaultView.requestAnimationFrame;
      if (raf) raf.call(doc.defaultView, render); else setTimeout(render, 0);
    }
    root.addEventListener('change', schedule);
    root.addEventListener('click', function (event) { if (event.target.closest('[data-model], [data-package], [data-mount], variant-selects')) schedule(); });
    var Observer = doc.defaultView && doc.defaultView.MutationObserver;
    if (Observer) {
      var observer = new Observer(function (records) {
        var meaningful = records.some(function (record) {
          if (record.target.nodeType === 1 && record.target.closest('[data-bmva], [data-bmva-list], [data-bmva-single], [data-compare-avail]')) return false;
          if (record.type === 'childList') {
            return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (child) {
              return child.nodeType === 1 && !child.matches('[data-bmva], [data-bmva-list], [data-bmva-single]');
            });
          }
          return true;
        });
        if (meaningful) schedule();
      });
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-selected-variant-id', 'checked', 'selected'] });
    }
    render();
  }

  return { describeVariant: describeVariant, resolveVariant: resolveVariant, formatDate: formatDate, init: init };
});
